export const FRONTEND_VERSION = 'v1.1.0';
